import { render, staticRenderFns } from "./VsInputPhone.vue?vue&type=template&id=577c813d&scoped=true&"
import script from "./VsInputPhone.vue?vue&type=script&lang=js&"
export * from "./VsInputPhone.vue?vue&type=script&lang=js&"
import style0 from "./VsInputPhone.vue?vue&type=style&index=0&id=577c813d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577c813d",
  null
  
)

export default component.exports